import { render } from "./AnimatedLoader.vue?vue&type=template&id=8a0e2420&scoped=true"
const script = {}

import "./AnimatedLoader.vue?vue&type=style&index=0&id=8a0e2420&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a0e2420"]])

export default __exports__